import { apiUrl } from '../config/backend';

export const BASE_PATH = apiUrl("/api/v3");
